import * as React from 'react';
import { useHistory } from 'react-router';
import { useAuth } from '../../../../App';
import { OrthodonticReferralResponseApi } from '../../../../api/OrthodonticReferralResponseApi';
import { ICareProvider } from '../../../../models/ICareProvider';
import { IForwardOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { Modal, ModalBody, AlertMessage, AlertType, ModalSize, HiddenInput, ModalFooter, CustomButton, ButtonType, CustomSubmitButton } from 'soprasteria-ui-library';
import { CareProviderDropdown } from '../../../CareProviderDropdown/CareProviderDropdown';

interface IOrthodonticReferralForwardModal {
    orthodonticReferralId: number;
    renderForm: boolean;
    onFormClose: () => void;
}

export const OrthodonticReferralForwardModal: React.FunctionComponent<IOrthodonticReferralForwardModal> = ({ orthodonticReferralId, renderForm, onFormClose }) => {
    const history = useHistory();
    const abortController = new AbortController();
    const auth = useAuth();
    const api = new OrthodonticReferralResponseApi(auth);
    const [isForwarding, setIsForwarding] = React.useState<boolean>(false);
    const [careProviders, setCareProviders] = React.useState<ICareProvider[]>();
    const [isFetchingCareProviders, setIsFetchingCareProviders] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();

    React.useEffect(() => {
        getCareProviders();

        return () => {
            abortController.abort();
        }
    }, [])

    const forwardOrthodonticReferral = (data: IForwardOrthodonticReferral) => {
        setIsForwarding(true);
        api.forwardOrthodonticReferral(data,
            () => {
                document.getElementById("close-forward-orthodontic-referral-modal")?.click();
                document.getElementById("open-redirect-from-orthodontic-referral-modal")?.click();
            },
            (error) => {
                setErrorMessage(error);
            },
            () => {
                setIsForwarding(false);
            })
    }

    const getCareProviders = () => {
        setIsFetchingCareProviders(true);
        api.getCareProvidersWithActiveSelectionAreaContracts((data) => setCareProviders(data),
            undefined, () => setIsFetchingCareProviders(false));
    }

    return (
        <>
            <Modal header="Vidarebefordra ortodontiremiss" id="forward-orthodontic-referral-modal" modalSize={ModalSize.large}>
                {
                    renderForm ?
                        <>
                            <ModalBody>
                                <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                                <p>Om du vidarebefordrar den här ortodontiremissen så kommer du inte längre ha behörighet att se den och du kommer att dirigeras tillbaka till föregående sida.</p>
                                <HiddenInput name="orthodonticReferralId" value={orthodonticReferralId.toString()} />
                                <CareProviderDropdown name="careProviderId" careProviders={careProviders} isLoading={careProviders === undefined} label="Konsulttandläkare" placeholder="Välj konsulttandläkare" required showSelectionArea/>
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-forward-orthodontic-referral-modal" onClick={() => { onFormClose(); }} />
                                <CustomSubmitButton onButtonSubmit={forwardOrthodonticReferral} disabled={isForwarding || isFetchingCareProviders} isLoading={isForwarding}>Vidarebefordra</CustomSubmitButton>
                            </ModalFooter>
                        </>
                        : null
                }
            </Modal>
            <span className="d-none">
                <CustomButton buttonType={ButtonType.general} buttonText="Gå tillbaka" id="open-redirect-from-orthodontic-referral-modal" data-target="#redirect-from-orthodontic-referral-modal" data-toggle="modal" />
            </span>
            <Modal header="Ortodontiremiss vidarebefordrad" id="redirect-from-orthodontic-referral-modal" modalSize={ModalSize.normal}>
                <ModalBody>
                    <p className="text-left">Ortodontiremissen har nu vidarebefordrats och du har inte längre behörighet till den.</p>
                </ModalBody>
                <ModalFooter>
                    <CustomButton buttonType={ButtonType.general} buttonText="Gå tillbaka" data-dismiss="modal" onClick={() => history.goBack()} />
                </ModalFooter>
            </Modal>
        </>
    )
}